import React, { createContext, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import DrawerFooter from './drawer/DrawerFooter';
import './createForms.css';
import './drawerBody.css';

// fb-224 — the shell drawer body + Close-left footer for forms that were written as stand-alone panels (Record
// Delivery, Make Payment, Return/refund, Edit, Cancel, Add Discount, Add Fees ...). The panel keeps its fields,
// validation and handlers untouched; only its ACTION ROW moves: <DrawerActions> portals the panel's primary
// button(s) into this footer (Close on the left - rendered by DrawerFooter, once - the main action `btn success` on the right), and falls back to the
// panel's original inline row when it is rendered outside a drawer (other pages), so nothing changes there.
const SlotCtx = createContext(null);

export default function DrawerBody({ onClose, foot = true, children }) {
  const [slot, setSlot] = useState(null);
  return (
    <SlotCtx.Provider value={slot}>
      <div className="dr-body">{children}</div>
      {foot && <DrawerFooter onClose={onClose} primary={<div className="dr-foot-actions" ref={setSlot} />} />}
    </SlotCtx.Provider>
  );
}

// children: (inFoot) => the primary button(s). inFoot -> give them className="btn success" (no inline style);
// otherwise the original inline style. `legacyRow` = the original row's class (drawerBody.css .act-row), `legacyClose` = its Cancel/Close button
// (`closeFirst` when the original put it left of the primary).
export function DrawerActions({ children, legacyRow, legacyClose, closeFirst = false }) {
  const slot = useContext(SlotCtx);
  if (slot) return createPortal(children(true), slot);
  return <div className={legacyRow}>{closeFirst && legacyClose}{children(false)}{!closeFirst && legacyClose}</div>;
}
